module.exports = __webpack_public_path__ + "img/mobile.adf58854.png";